import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatPaginator, Sort} from "@angular/material";
import {TranslateService} from "@ngx-translate/core";
import {merge, of as observableOf} from "rxjs";
import {catchError, map, startWith, switchMap} from "rxjs/operators";
import { InprocessService } from "../service/http/inprocess.service";
import { Package } from "../model/Package";
import {Router} from "@angular/router";
import {AcceptDeclineDialogComponent} from "../dialog/accept-decline-dialog/accept-decline-dialog.component";
import {FileuploadService} from "../service/http/fileupload.service";

@Component({
  selector: 'app-inprocess',
  templateUrl: './inprocess.component.html',
  styleUrls: ['./inprocess.component.css']
})
export class InprocessComponent implements OnInit {

  displayedColumns: string[] = ['id', 'identifier', 'pos', 'model', 'lang', 'status', 'creationDate', 'actions'];
  data: Package[] = [];
  isLoadingResults = false;
  resultsLength = 0;
  e: number = 2.71;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private inprocessService: InprocessService,
              private translate: TranslateService,
              private _router: Router,
              public dialog: MatDialog,
              private uploadService: FileuploadService) { }

  ngOnInit() {
    this.loadTableData();
  }

  loadTableData() {

    merge(this.paginator.page)
      .pipe(
        startWith([]),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.inprocessService.getInProcessPackagesPagination(this.paginator.pageIndex + 1);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.resultsLength = data["totalElements"];
          return data["content"];
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      ).subscribe(data => {
        this.data = data;
    });
  }

  deletePackage(id: number) {

    const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
      width: '250px',
      data: {
        title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
        message: this.translate.instant('Do you really want to delete the package No. ' + id + ' ?'),
        icon: {
          add: false,
          name: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true) {
        this.inprocessService.deleteInProcessPackage(id).subscribe(data => {
          this.loadTableData();
        });
      }
    });
  }

  editPackage(id) {
    sessionStorage.setItem('currentPackageId', id);
    this.uploadService.setCurrentPackageId(id);
    this._router.navigate(['/upload/drivers-manual']);
  }

  sortData(sort: Sort) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data = data;
      return;
    }

    this.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.id, b.id, isAsc);
        case 'identifier': return this.compare(a.identifier, b.identifier, isAsc);
        case 'pos': return this.compare(a.pos, b.pos, isAsc);
        case 'model': return this.compare(a.model.name, b.model.name, isAsc);
        case 'lang': return this.compare(a.language.name, b.language.name, isAsc);
        case 'creationDate': return this.compare(a.creationDate, b.creationDate, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
